import { useState } from 'react'
import { t } from 'i18next'
import AlertDialog from 'src/components/shared/ui/AlertDialog/AlertDialog'
import { AlertType } from 'src/components/shared/ui/AlertDialog/enums'

type Props = {
  onClose: () => void
  onConnect: (signal: boolean) => void
  open: boolean
}

export default function NoConnectionDialog({ open, onClose, onConnect }: Props): JSX.Element {
  const [connectingAction, setConnectingAction] = useState(true)
  const message = t('dialog.message.no_connection_dialog')
  // const title = t('dialog.message.no_connection_title')

  function doCancel() {
    setConnectingAction(false)
    onClose()
  }

  function doConnect() {
    setConnectingAction(true)
    onConnect(connectingAction)
  }

  return (
    <AlertDialog
      show={open}
      type={AlertType.INFO}
      title=""
      message={message}
      close={() => doCancel()}
      accept={() => doConnect()}
      cancel={() => doCancel()}
      secondaryButtonText={t('actions.continue_offline')}
      primaryButtonText={t('actions.connect')}
    />
  )
}
